/**
 * Lifecycle of a generic inbound-webhook ledger row (webhook-service). The
 * receiver inserts `RECEIVED`; a consuming worker atomically claims it into
 * `PROCESSING` (so a concurrent worker can't double-process), then advances it
 * to `PROCESSED` or `FAILED`. A `FAILED` row is re-claimable on SQS retry.
 * Provider-agnostic — one enum for every inbound source.
 */
export enum WebhookStatus {
	RECEIVED = 'received',
	PROCESSING = 'processing',
	PROCESSED = 'processed',
	FAILED = 'failed',
}

/** Known inbound webhook providers. Extend as new sources are integrated. */
export enum WebhookProvider {
	WORKFRONT = 'workfront',
}
